import { client } from "./index";

// Visits, orders and sales (Super Admin: every website; store owner: their own): { days, range, site, totals, series, sites, stores }
// range: '1h', '1d', 7, 30, 90
// site: one store's slug, or "" for all of them
export const getAnalytics = (range, site) => client.get("/admin/analytics", { params: { range, ...(site ? { site } : {}) } });
export const getSessionActivities = (sessionId) => client.get(`/admin/analytics/session/${sessionId}/activities`);
export const getAiInsights = (range, site) => client.get("/admin/analytics/ai-insights", { params: { range, ...(site ? { site } : {}) } });
// Analytics -> Admin Tracker (Super Admin): customer stores for the picker, and one store's admin activity
export const getTrackerStores = () => client.get("/admin/admin-tracker/stores");
export const getAdminTracker = (slug, days) => client.get(`/admin/admin-tracker/${encodeURIComponent(slug)}`, { params: { days } });
